import { css } from 'goober';
import React, { memo } from 'react';
const Holder = css `
  display: block;
  width: 22px;
  height: 20px;
`;
const PlayBtn = () => {
    return (React.createElement("span", { className: Holder },
        React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "72", height: "72", viewBox: "0 0 72 72" },
            React.createElement("defs", null,
                React.createElement("path", { id: "b", d: "M24 4C12.96 4 4 12.96 4 24s8.96 20 20 20 20-8.96 20-20S35.04 4 24 4zm-4 29V15l12 9-12 9z" }),
                React.createElement("filter", { id: "a", width: "280%", height: "280%", x: "-90%", y: "-65%", filterUnits: "objectBoundingBox" },
                    React.createElement("feOffset", { dy: "8", in: "SourceAlpha", result: "shadowOffsetOuter1" }),
                    React.createElement("feGaussianBlur", { in: "shadowOffsetOuter1", result: "shadowBlurOuter1", stdDeviation: "8" }),
                    React.createElement("feColorMatrix", { in: "shadowBlurOuter1", result: "shadowMatrixOuter1", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.319802989 0" }),
                    React.createElement("feOffset", { dy: "2", in: "SourceAlpha", result: "shadowOffsetOuter2" }),
                    React.createElement("feGaussianBlur", { in: "shadowOffsetOuter2", result: "shadowBlurOuter2", stdDeviation: "4" }),
                    React.createElement("feColorMatrix", { in: "shadowBlurOuter2", result: "shadowMatrixOuter2", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.319604846 0" }),
                    React.createElement("feMerge", null,
                        React.createElement("feMergeNode", { in: "shadowMatrixOuter1" }),
                        React.createElement("feMergeNode", { in: "shadowMatrixOuter2" })))),
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("path", { d: "M12 4h48v48H12z" }),
                React.createElement("g", { transform: "translate(12 4)" },
                    React.createElement("use", { fill: "#000", filter: "url(#a)", xlinkHref: "#b" }),
                    React.createElement("use", { fill: "#FFF", xlinkHref: "#b" }))))));
};
export default memo(PlayBtn);
//# sourceMappingURL=index.js.map